import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
    query afpsActive {
        afpsActive {
            id
            name
            items {
                percentage_flow
                mixed_percentage
                contribution
                insurance_premium
                flow
                mixed
                safe_stop
                year
                month
            }
            observations
            is_active
            status_text
        }
    }
`
const GET_WITH_PAGINATION = gql`
    query afpsWithPagination ($page: Int, $perPage: Int) {
        afpsWithPagination (page: $page, first: $perPage) {
            paginatorInfo {
                currentPage
                count
                hasMorePages
                perPage
                total
            }
            data {
                id
                name
                items {
                    percentage_flow
                    mixed_percentage
                    contribution
                    insurance_premium
                    flow
                    mixed
                    safe_stop
                    year
                    month
                }
                observations
                is_active
                status_text
            }
        }
    }
`
/**
 * Mutations
 */
 const CREATE = gql`
 mutation createAfp ($input: AfpCreateInput!) {
    createAfp (input: $input) {
         id
         name
         is_active
         status_text
     }
 }
`

const UPDATE = gql`
 mutation updateAfp ($id: ID!, $input: AfpUpdateInput!) {
    updateAfp (id: $id, input: $input) {
        id
        name
        is_active
        status_text
     }
 }
`

const CHANGE_STATUS = gql`
 mutation changeStatusAfp ($id: ID!, $input: AfpChangeStatusInput!) {
    changeStatusAfp (id: $id, input: $input) {
        id
        name
        is_active
        status_text
     }
 }
`

const DELETE = gql`
 mutation deleteAfp ($id: ID!) {
     deleteAfp (id: $id) {
        id
        name
        is_active
        status_text
     }
 }
`

export {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    CHANGE_STATUS,
    DELETE
}
